import { createMap, forMember, mapFrom, mapWith, constructUsing } from "@automapper/core";
import { FeatureAccessStatus } from "../../contract/pam.js";
import { P2PLimitsViewModelTypeName, P2PLimitsTypeName, P2PGlobalSettingsViewModelTypeName, P2PGlobalSettingsModelTypeName } from "../p2p-global-settings/constants.js";
const p2pPlayerSettingsMappingKeys = {
  serverModel: "P2PPlayerSettings.Model",
  viewModel: "P2PPlayerSettings.ViewModel",
  queryFields: "P2PPlayerSettings.QueryFields",
  viewModelKeys: "P2PPlayerSettings.ViewModelKeys",
  personalSettingsModel: "P2PPlayerSettings.PersonalSettingsModel",
  personalSettingsViewModel: "P2PPlayerSettings.PersonalSettingsViewModel"
};
class P2PPlayerSettingsMapping {
  createMapping(mapper) {
    createMap(
      mapper,
      p2pPlayerSettingsMappingKeys.serverModel,
      p2pPlayerSettingsMappingKeys.personalSettingsViewModel,
      forMember(
        (vm) => vm.is_p2p_locked,
        mapFrom((m) => m?.user_profile?.p2p_status === FeatureAccessStatus.Locked)
      ),
      forMember(
        (vm) => vm.daily_transfer_count,
        mapFrom((m) => m?.personal_limits_v2?.daily_transfer_count)
      ),
      forMember(
        (vm) => vm.credit_limits,
        mapWith(P2PLimitsViewModelTypeName, P2PLimitsTypeName, (m) => m?.personal_limits_v2?.credit_limits)
      ),
      forMember(
        (vm) => vm.debit_limits_to_agent,
        mapWith(P2PLimitsViewModelTypeName, P2PLimitsTypeName, (m) => m?.personal_limits_v2?.debit_limits_to_agent)
      ),
      forMember(
        (vm) => vm.debit_limits_to_player,
        mapWith(P2PLimitsViewModelTypeName, P2PLimitsTypeName, (m) => m?.personal_limits_v2?.debit_limits_to_player)
      )
    );
    createMap(
      mapper,
      p2pPlayerSettingsMappingKeys.serverModel,
      p2pPlayerSettingsMappingKeys.viewModel,
      forMember(
        (vm) => vm.global_settings,
        mapWith(P2PGlobalSettingsViewModelTypeName, P2PGlobalSettingsModelTypeName, (m) => m?.global_settings)
      ),
      forMember(
        (vm) => vm.personal_settings,
        mapWith(p2pPlayerSettingsMappingKeys.personalSettingsViewModel, p2pPlayerSettingsMappingKeys.serverModel, (m) => m)
      )
    );
    createMap(
      mapper,
      p2pPlayerSettingsMappingKeys.viewModelKeys,
      p2pPlayerSettingsMappingKeys.queryFields,
      constructUsing((m) => {
        const summaryMapper = {
          "global_settings.is_kyc_approved": "global_settings.kyc_status",
          "global_settings.country": "global_settings.country",
          "global_settings.license_type": "global_settings.license_type",
          "global_settings.is_agent": "global_settings.is_agent",
          "global_settings.p2p_sender": "global_settings.p2p_sender",
          "global_settings.is_p2p_locked": "global_settings.p2p_status",
          "global_settings.limits.daily": "global_settings.limits.daily",
          "global_settings.limits.weekly": "global_settings.limits.weekly",
          "global_settings.limits.monthly": "global_settings.limits.monthly",
          "global_settings.daily_transfer_count": "global_settings.daily_transfer_count",
          "global_settings.credit_limits.daily": "global_settings.credit_limits.daily",
          "global_settings.credit_limits.weekly": "global_settings.credit_limits.weekly",
          "global_settings.credit_limits.monthly": "global_settings.credit_limits.monthly",
          "global_settings.debit_limits_to_agent.daily": "global_settings.debit_limits_to_agent.daily",
          "global_settings.debit_limits_to_agent.weekly": "global_settings.debit_limits_to_agent.weekly",
          "global_settings.debit_limits_to_agent.monthly": "global_settings.debit_limits_to_agent.monthly",
          "global_settings.debit_limits_to_player.daily": "global_settings.debit_limits_to_player.daily",
          "global_settings.debit_limits_to_player.weekly": "global_settings.debit_limits_to_player.weekly",
          "global_settings.debit_limits_to_player.monthly": "global_settings.debit_limits_to_player.monthly",
          "personal_settings.is_p2p_locked": "user_profile.p2p_status",
          "personal_settings.daily_transfer_count": "personal_limits_v2.daily_transfer_count",
          "personal_settings.credit_limits.daily": "personal_limits_v2.credit_limits.daily",
          "personal_settings.credit_limits.weekly": "personal_limits_v2.credit_limits.weekly",
          "personal_settings.credit_limits.monthly": "personal_limits_v2.credit_limits.monthly",
          "personal_settings.debit_limits_to_agent.daily": "personal_limits_v2.debit_limits_to_agent.daily",
          "personal_settings.debit_limits_to_agent.weekly": "personal_limits_v2.debit_limits_to_agent.weekly",
          "personal_settings.debit_limits_to_agent.monthly": "personal_limits_v2.debit_limits_to_agent.monthly",
          "personal_settings.debit_limits_to_player.daily": "personal_limits_v2.debit_limits_to_player.daily",
          "personal_settings.debit_limits_to_player.weekly": "personal_limits_v2.debit_limits_to_player.weekly",
          "personal_settings.debit_limits_to_player.monthly": "personal_limits_v2.debit_limits_to_player.monthly"
        };
        return summaryMapper[m];
      })
    );
  }
}
export {
  P2PPlayerSettingsMapping,
  p2pPlayerSettingsMappingKeys
};
//# sourceMappingURL=mapper.js.map
